module.exports = __webpack_public_path__ + "static/profilePhoto-880520debeb8e06636f9dfab187f0e41.jpg";